import { render, staticRenderFns } from "./ListagemTransportadoras.vue?vue&type=template&id=2e9bd01e"
import script from "./ListagemTransportadoras.vue?vue&type=script&lang=js"
export * from "./ListagemTransportadoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports